import "./Intro.css"

function Intro() {
  return (
    <section
      className="hero-section"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(0,0,0,0) 60%, #000000), url('/images/greenBoard.jpg')"
      }}
    >
    <div class="hero-content">
      <h2>Hi I'm <b>Kieran</b>!<br/> I am a Software Engineering student at RIT who is passionate about secure systems, clean design, and
        building effective products.</h2>
    </div>
    </section>
  );
}

export default Intro;
